import React from 'react'
import PropTypes from 'prop-types'
import AusbildungsplanStaticPages from './AusbildungsplanStaticPages'
import AusbildungsplanCategories from './AusbildungsplanCategories'

function AusbildungsplanContentMenu(props) {
  const {levelMenu, contextualUserId, pathParts, pageList, chapters} = props

  const hasStaticPages = pageList.length > 0

  return (
    <div className={`menu-partial ${levelMenu()}`}>
      {hasStaticPages && (
        <AusbildungsplanStaticPages
          contextualUserId={contextualUserId}
          currentItem={pathParts[2]}
          pageList={pageList}
        />
      )}
      <AusbildungsplanCategories contextualUserId={contextualUserId} currentItem={pathParts[1]} chapters={chapters} />
    </div>
  )
}

AusbildungsplanContentMenu.propTypes = {
  contextualUserId: PropTypes.number.isRequired,
  levelMenu: PropTypes.func,
  chapters: PropTypes.array.isRequired,
  pageList: PropTypes.array.isRequired,
  pathParts: PropTypes.array.isRequired,
}

export default AusbildungsplanContentMenu
